import { default as MuiListItemAvatar } from '@mui/material/ListItemAvatar';

/**
 * ListItemAvatar displays an avatar within a ListItem.
 *
 * Demos:
 *
 * - [List Item Avatar](https://unify.workiva.org/components/list?tab=code#adornments)
 *
 * API:
 *
 * - [ListItemAvatar API](https://unify.workiva.org/components/list?tab=props#listitemavatar)
 */
export const ListItemAvatar = MuiListItemAvatar;
export {
  type ListItemAvatarProps,
  listItemAvatarClasses,
} from '@mui/material/ListItemAvatar';
